// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { ILTCourse } from '../../types/Model';
import { actionCreatorsList, RootAction } from '../rootActionCreator';

export interface IltCourseInformationState {
  iltCourses: Record<number, ILTCourse>;
  isLoading: boolean;
  isInformationFetching: boolean;
  isProgressing: boolean;
  isEnding: boolean;
  error?: Error;
}

const { getIltCourseDataActions } = actionCreatorsList;

export const initialState: IltCourseInformationState = {
  iltCourses: {},
  isLoading: true,
  isInformationFetching: false,
  isProgressing: false,
  isEnding: false,
};

const iltCourseDataReducer = (state = initialState, action: RootAction): IltCourseInformationState => {
  switch (action.type) {
    case getType(getIltCourseDataActions.request): {
      return {
        ...state,
        isLoading: !action.payload.preventLoading,
        error: undefined
      };
    }
    case getType(getIltCourseDataActions.success): {
      const { payload } = action;
      const iltCourse = payload.iltCourseData;
      return {
        ...state,
        isLoading: false,
        iltCourses: {
          ...state.iltCourses,
          [iltCourse.id]: iltCourse
        },
      };
    }
    case getType(getIltCourseDataActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    }
    default: {
      return state;
    }
  }
}

export { iltCourseDataReducer as default};
